<div *ngIf="customError" [ngClass]="{'error': errorPlacementFloating, 'static-error': !errorPlacementFloating }">
    <div *ngIf="customError"><i class="fas fa-exclamation-triangle"></i>{{customMess}}</div>
</div>

<div class="kn-input-message" [ngClass]="{'warning': customWarning}" *ngIf="customWarning">
    <div *ngIf="customWarning"><i class="fas fa-exclamation-triangle"></i> <span class="kn-input-message-text">{{customMess}}</span></div>
</div>